// Auto-managed table of contents for the Plugin SDK documentation.
// Order here drives sidebar order and prev/next navigation.

import dgIndex from './developer-guide/00-index.md?raw';
import dg01 from './developer-guide/01-introduction.md?raw';
import dg02 from './developer-guide/02-quickstart.md?raw';
import dg03 from './developer-guide/03-anatomy.md?raw';
import dg04 from './developer-guide/04-manifest-and-capabilities.md?raw';
import dg05 from './developer-guide/05-plugin-context.md?raw';
import dg06 from './developer-guide/06-seams-tools-resources.md?raw';
import dg07 from './developer-guide/07-seams-events.md?raw';
import dg08 from './developer-guide/08-seams-closure.md?raw';
import dg09 from './developer-guide/09-trust-and-security.md?raw';
import dg10 from './developer-guide/10-lifecycle-and-installation.md?raw';
import dg11 from './developer-guide/11-telemetry-debugging-testing.md?raw';
import dg12 from './developer-guide/12-best-practices.md?raw';
import dg13 from './developer-guide/13-architect-tabs.md?raw';

import refIndex from './reference/00-index.md?raw';
import ref01 from './reference/01-manifest-schema.md?raw';
import ref02 from './reference/02-capabilities.md?raw';
import ref03 from './reference/03-effects.md?raw';
import ref04 from './reference/04-reject-reasons.md?raw';
import ref05 from './reference/05-context-api.md?raw';
import ref06 from './reference/06-events.md?raw';
import ref07 from './reference/07-cli.md?raw';
import ref08 from './reference/08-host-config.md?raw';
import ref09 from './reference/09-telemetry-events.md?raw';
import ref10 from './reference/10-architect-tabs.md?raw';

export interface SdkEntry {
  slug: string;
  title: string;
  group: 'Developer Guide' | 'Reference Manual';
  body: string;
}

export const sdkEntries: SdkEntry[] = [
  { slug: 'guide-overview', title: 'Overview', group: 'Developer Guide', body: dgIndex },
  { slug: 'guide-introduction', title: '1. Introduction', group: 'Developer Guide', body: dg01 },
  { slug: 'guide-quickstart', title: '2. Quickstart', group: 'Developer Guide', body: dg02 },
  { slug: 'guide-anatomy', title: '3. Anatomy of a plugin', group: 'Developer Guide', body: dg03 },
  { slug: 'guide-manifest-capabilities', title: '4. Manifest & capabilities', group: 'Developer Guide', body: dg04 },
  { slug: 'guide-plugin-context', title: '5. The PluginContext', group: 'Developer Guide', body: dg05 },
  { slug: 'guide-seams-tools', title: '6. Seams: tools & resources', group: 'Developer Guide', body: dg06 },
  { slug: 'guide-seams-events', title: '7. Seams: events', group: 'Developer Guide', body: dg07 },
  { slug: 'guide-seams-closure', title: '8. Closure seams', group: 'Developer Guide', body: dg08 },
  { slug: 'guide-trust-security', title: '9. Trust & security', group: 'Developer Guide', body: dg09 },
  { slug: 'guide-lifecycle', title: '10. Installation & lifecycle', group: 'Developer Guide', body: dg10 },
  { slug: 'guide-telemetry-testing', title: '11. Telemetry, debugging, testing', group: 'Developer Guide', body: dg11 },
  { slug: 'guide-best-practices', title: '12. Best practices & pitfalls', group: 'Developer Guide', body: dg12 },
  { slug: 'guide-architect-tabs', title: '13. Architect tabs', group: 'Developer Guide', body: dg13 },

  { slug: 'reference-overview', title: 'Overview', group: 'Reference Manual', body: refIndex },
  { slug: 'reference-manifest-schema', title: 'Manifest schema', group: 'Reference Manual', body: ref01 },
  { slug: 'reference-capabilities', title: 'Capabilities', group: 'Reference Manual', body: ref02 },
  { slug: 'reference-effects', title: 'Effects', group: 'Reference Manual', body: ref03 },
  { slug: 'reference-reject-reasons', title: 'Reject reasons', group: 'Reference Manual', body: ref04 },
  { slug: 'reference-context-api', title: 'PluginContext API', group: 'Reference Manual', body: ref05 },
  { slug: 'reference-events', title: 'Events', group: 'Reference Manual', body: ref06 },
  { slug: 'reference-cli', title: 'dg plugin CLI', group: 'Reference Manual', body: ref07 },
  { slug: 'reference-host-config', title: 'Host configuration', group: 'Reference Manual', body: ref08 },
  { slug: 'reference-telemetry-events', title: 'Telemetry events', group: 'Reference Manual', body: ref09 },
  { slug: 'reference-architect-tabs', title: 'Architect tabs', group: 'Reference Manual', body: ref10 },
];

export const sdkBySlug = new Map(sdkEntries.map((e) => [e.slug, e]));
